import { useTranslation } from "react-i18next";

export default function VerifyEmailCrumb(): string {
  const { t } = useTranslation();
  return t("crumb.VerifyEmail");
}
